module.exports = __webpack_public_path__ + "img/kong.07ebc524.png";